import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface NumberStepperProps {
  value: number;
  onChange: (value: number) => void;
  label: string;
  max?: number;
}

/**
 * Used for small whole numbers such as dependants, where tapping is faster and
 * far less error-prone on a phone than typing into a field.
 */
export function NumberStepper({
  value,
  onChange,
  label,
  max = 12
}: NumberStepperProps) {
  const set = (next: number) => onChange(Math.min(max, Math.max(0, next)));
  return <div className="flex items-center justify-center gap-6" data-id="element-225" data-mp="7v8thalh5hgk">
      <button type="button" onClick={() => set(value - 1)} disabled={value <= 0} aria-label={`Decrease ${label}`} className="flex items-center justify-center w-14 h-14 rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 text-slate-600 dark:text-slate-300 hover:border-primary-400 disabled:opacity-40 disabled:hover:border-slate-200 transition-colors" data-id="element-226" data-mp="7tp8x7ssck8z">
        <MinusIcon className="w-6 h-6" data-id="element-227" data-mp="2w3hvg6rdf353" />
      </button>

      <p className="text-5xl font-extrabold text-slate-900 dark:text-white tabular-nums min-w-[3ch] text-center" aria-live="polite" aria-label={`${label}: ${value}`} data-id="element-228" data-mp="2w517fl5zus12">
        {value}
      </p>

      <button type="button" onClick={() => set(value + 1)} disabled={value >= max} aria-label={`Increase ${label}`} className="flex items-center justify-center w-14 h-14 rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 text-slate-600 dark:text-slate-300 hover:border-primary-400 disabled:opacity-40 disabled:hover:border-slate-200 transition-colors" data-id="element-229" data-mp="2hebv2fgsr6vm">
        <PlusIcon className="w-6 h-6" data-id="element-230" data-mp="1yg9b4f33w04o" />
      </button>
    </div>;
}